import { render } from "./DropZone.vue?vue&type=template&id=4b21002a&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"

import "./DropZone.vue?vue&type=style&index=0&id=4b21002a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b21002a"]])

export default __exports__